module.exports = __webpack_public_path__ + "img/cal-diners.5f93a0cd.svg";